import React from "react";

type Props = {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  id?: string;
  name?: string;
  disabled?: boolean;
  className?: string;
  label?: React.ReactNode;
};

export default function CustomCheckbox({
  checked = false,
  onChange,
  id,
  name,
  disabled = false,
  className = "",
  label,
}: Props) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log("Checkbox changed:", e.target.checked);
    onChange?.(e.target.checked);
  };

  return (
    <div className="custom-checkbox-wrapper">
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className={`custom-checkbox-component ${className}`}
      />
      {label && <span className="custom-checkbox-label">{label}</span>}
    </div>
  );
}
